import PageTabs from './PageTabs'

export default PageTabs



// WEBPACK FOOTER //
// ./src/legacy/components/PageTabs/index.js